import styled from 'styled-components';

const VolumeItemWrapper = styled.div`
  z-index: 10;
  border-radius: 8px;
  width: 100%;
  &:hover {
    background-color: ${({ theme }) => theme.colors.boxShadow[15]};
    .trash-icon {
      visibility: visible;
    }
  }

  &.open-volume {
    background-color: ${({ theme }) => theme.colors.primary[50]};
  }

  .volume-box {
    width: 100%;
  }

  .trash-icon {
    visibility: hidden;
  }

  .buttons-section {
    button {
      background-color: inherit;
    }
  }

  .volume-item-name {
    width: 100%;
    max-width: 268px;
    form {
      width: 100%;
    }
    .input-content {
      display: flex;
    }
    textarea {
      resize: none;
      height: 20px;
      min-height: 20px;
      height: auto;
      min-width: 100%;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      color: ${({ theme }) => theme.colors.dark[100]};
      background-color: inherit;
      border: none;
      padding: 0;
    }
  }
`;

export default VolumeItemWrapper;
